module.exports = __webpack_public_path__ + "img/academy_members.a655c8d7.svg";